'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import SafeLink from '@/components/SafeLink';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import style from './style.module.scss';

export default function Module({ moduleData, pageName }: { moduleData: any; pageName: string }) {
  const pageConfig: any = {};

  const initConfig = (moduleData: any) => {
    pageConfig.data = moduleData.dataBatch?.categoryList || [];
    pageConfig.title = moduleData.dataStyle?.config.title || '';
    pageConfig.moduleCode = moduleData.moduleCode || ''; // 动态获取类名
  };
  initConfig(moduleData);

  if (!pageConfig.data) {
    return null;
  }

  // 根据数据长度判断使用单行还是双行布局
  const isSingleRow = pageConfig.data.length < 8;
  const gridTemplateRows = isSingleRow ? '126px' : 'repeat(2, 126px)';

  return (
    <div className={style.bg}>
      <div className={pageConfig.moduleCode ? style[pageConfig.moduleCode] : ''}>
        {pageConfig.title ? (
          <>
            <div className={style.header}>
              <div className={style.title}>{pageConfig.title}</div>
            </div>
          </>
        ) : null}

        {/* 容器：双行滚动 */}
        <div
          className={style.scrollContainer}
          // style={{ paddingTop: pageConfig.title ? '0' : '12px' }}
        >
          <div className={style.scrollContent} style={{ gridTemplateRows }}>
            {pageConfig.data.map((item: any, index: number) => (
              <SafeLink
                href={`/s?k=${encodeURIComponent(item?.category?.cateName)}&l3=${encodeURIComponent(
                  item?.category?.cateId,
                )}`}
                key={item?.category?.cateId}
                onClick={(e) => {
                  spmTrackingUtils.spmClick({
                    spm: `a0145.b002244.c00002473.${index + 1}`,
                    page_id: 'Mini_Hp',
                    event_id: 'Home_Mini_Hp_Popular_Categories',
                    target: e.target as HTMLElement,
                    json_param: JSON.stringify({
                      index: index,
                      firstcid: '-100',
                      secondcid: '-100',
                      thirdcid: item?.category?.cateId,
                      Mini_Hp_Name: pageName || 'home',
                    }),
                  });
                }}
              >
                <div
                  className={style.item}
                  data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                  data-exp={JSON.stringify({
                    spm: `a0145.b002244.c00002473.${index + 1}`,
                    event_id: 'Home_Mini_Hp_Popular_Categories_Expo',
                    page_id: 'Mini_Hp',
                    json_param: {
                      index: index,
                      firstcid: '-100',
                      secondcid: '-100',
                      thirdcid: item?.category?.cateId,
                      Mini_Hp_Name: pageName || 'home',
                    },
                  })}
                >
                  <div
                    className={style.bg}
                    style={{ backgroundColor: item?.category?.backgroundColor }}
                  >
                    <CDNImage
                      src={item?.category?.cateImageUrl || ''}
                      width={100}
                      height={100}
                      alt={item?.category}
                    />
                    <p>{item?.category?.cateName}</p>
                  </div>
                </div>
              </SafeLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
